import { logger } from '../lib/logger';
import { frontendLogger } from '../atoms/v3/debugAtoms';

// 双重日志记录：同时发送到 Axiom 和前端调试面板
const dualLog = {
  info: (message: string, data?: any) => {
    logger.info(message, data);
    frontendLogger.info(message, data);
  }
};

// Global pushy manager to handle state outside React components
class PushyManager {
  private static instance: PushyManager;
  private deviceToken: string | null = null;
  private initialized: boolean = false;
  private listeners: Set<() => void> = new Set();

  static getInstance(): PushyManager {
    if (!PushyManager.instance) {
      PushyManager.instance = new PushyManager();
    }
    return PushyManager.instance;
  }

  setDeviceToken(token: string | null) {
    dualLog.info('🔥 [PushyManager] setDeviceToken called', { token });
    this.deviceToken = token;
    // Store in global variable for immediate access
    (window as any).__pushyDeviceToken = token;
    dualLog.info('🔥 [PushyManager] Token stored, notifying listeners');
    this.notifyListeners();
  }

  getDeviceToken(): string | null {
    const token = this.deviceToken || (window as any).__pushyDeviceToken || null;
    dualLog.info('🔥 [PushyManager] getDeviceToken called', {
      instanceToken: this.deviceToken,
      windowToken: (window as any).__pushyDeviceToken,
      finalToken: token
    });
    return token;
  }

  setInitialized(initialized: boolean) {
    this.initialized = initialized;
    this.notifyListeners();
  }

  isInitialized(): boolean {
    return this.initialized;
  }

  // Add listener for state changes
  addListener(listener: () => void) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  private notifyListeners() {
    this.listeners.forEach(listener => {
      try {
        listener();
      } catch (error) {
        console.error('Error in pushy manager listener:', error);
      }
    });
  }
}

export const pushyManager = PushyManager.getInstance();
